import { FormEvent, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { LogIn, Loader2 } from 'lucide-react';
import { Logo } from '../shell/Logo';
import { useAuth } from './useAuth';
import { ApiError } from '../api/client';

export default function LoginPage(): JSX.Element {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const verified = params.get('verified') === 'true';
  const redirectTo = params.get('redirect_to') ?? '/';

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate(decodeURIComponent(redirectTo), { replace: true });
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.message || '로그인에 실패했습니다.');
      } else {
        setError('로그인에 실패했습니다.');
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={onSubmit}>
        <div className="auth-form__brand">
          <Logo size={20} showText={false} />
          <span className="auth-form__brand-name">Alpha Omega Quant</span>
        </div>
        <h1>로그인</h1>
        {verified && <div className="auth-banner">이메일 인증이 완료되었습니다. 로그인해주세요.</div>}
        <label>
          <span>이메일</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </label>
        <label>
          <span>비밀번호</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </label>
        {error && <div className="auth-error" role="alert">{error}</div>}
        <button type="submit" disabled={submitting}>
          {submitting ? (
            <Loader2 size={16} strokeWidth={1.75} className="pca-spin" />
          ) : (
            <LogIn size={16} strokeWidth={1.75} />
          )}
          {submitting ? '로그인 중...' : '로그인'}
        </button>
        <div className="auth-links">
          <Link to="/register">회원가입</Link>
          <Link to="/forgot-password">비밀번호 찾기</Link>
        </div>
      </form>
    </div>
  );
}
